import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

interface SiteModePageProps {
  mode: 'coming_soon' | 'maintenance';
}

const SiteModePage: React.FC<SiteModePageProps> = ({ mode }) => {
  const { login } = useAuth();
  const [showLogin, setShowLogin] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const ok = await login(password);
    if (!ok) {
      setError('Погрешна лозинка');
    }
    // If login succeeds, App.tsx will detect isAdmin and show the normal site
    setLoading(false);
    setPassword('');
  };

  return (
    <div className="site-mode-page">
      <div
        className="site-mode-bg"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.7)), url(/resource/slika.jpg)",
        }}
      />

      <div className="site-mode-content">
        <div className="site-mode-cross">{'\u2626'}</div>
        <h1 className="site-mode-title">Манастир Градац</h1>
        <div className="site-mode-divider" />

        {mode === 'coming_soon' ? (
          <>
            <h2 className="site-mode-heading">Сајт ускоро долази</h2>
            <p className="site-mode-message">
              Радимо на изради нашег веб сајта. Молимо вас за стрпљење — ускоро ћемо бити доступни.
            </p>
          </>
        ) : (
          <>
            <h2 className="site-mode-heading">Сајт се тренутно одржава</h2>
            <p className="site-mode-message">
              Наш сајт је тренутно у фази одржавања. Бићемо поново доступни у најкраћем могућем року.
            </p>
          </>
        )}

        <div className="site-mode-footer-text">
          Манастир Градац · Задужбина Свете краљице Јелене Анжујске
        </div>

        {/* Admin login — small link at the bottom */}
        <div className="site-mode-admin-section">
          {!showLogin ? (
            <button
              className="site-mode-admin-toggle"
              onClick={() => setShowLogin(true)}
            >
              Администрација
            </button>
          ) : (
            <form className="site-mode-login-form" onSubmit={handleLogin}>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Лозинка"
                autoFocus
                disabled={loading}
              />
              {error && <div className="site-mode-login-error">{error}</div>}
              <div className="site-mode-login-actions">
                <button type="submit" disabled={loading}>
                  {loading ? 'Пријава...' : 'Пријави се'}
                </button>
                <button
                  type="button"
                  onClick={() => { setShowLogin(false); setError(''); setPassword(''); }}
                >
                  Откажи
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default SiteModePage;
